"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20024ToJSON = exports.InlineResponse20024FromJSONTyped = exports.InlineResponse20024FromJSON = void 0;
var _1 = require("./");
function InlineResponse20024FromJSON(json) {
    return InlineResponse20024FromJSONTyped(json, false);
}
exports.InlineResponse20024FromJSON = InlineResponse20024FromJSON;
function InlineResponse20024FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'users': (json['users'].map(_1.UserRankDataFromJSON)),
    };
}
exports.InlineResponse20024FromJSONTyped = InlineResponse20024FromJSONTyped;
function InlineResponse20024ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'users': (value.users.map(_1.UserRankDataToJSON)),
    };
}
exports.InlineResponse20024ToJSON = InlineResponse20024ToJSON;
